import { createFileRoute } from "@tanstack/react-router";
import GrantDetail from "@/pages/GrantDetail";

export const Route = createFileRoute("/en/grants/$codigo")({
  component: GrantDetail,
});
